<template>
  <div v-if="firstShow" ref="holder"></div>
</template>

<script>
import FormDetailsConfig from "@/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig";

import PermissionsSet from "@/server/PermissionsSet";
import VBox from "@/components/VBox";
import FooterNavbar from "@/components/navbar/FooterNavbar";
import FormConfig from "@/server/com/silkplm/engine/forms/schema/definition/FormConfig";
import EntitiesList from "@/components/forms/EntitiesList";
import FooterButton from "@/components/navbar/FooterButton";
import FormsActions from "@/components/forms/FormsActions";
import FormsLoader from "@/components/forms/FormsLoader";
import CloseButton from "@/components/navbar/CloseButton";
import TemporaryList from "@/components/forms/TemporaryList"
import BaseFormConfig from "@/server/com/silkplm/engine/forms/schema/BaseFormConfig";
import Rpc from "@/Rpc";
import Vue from "vue";

import Renderers from "@/components/forms/renderers/Renderers";

let CLASSES = {};

export default {
  name: "CustomizedDetailsList",
  props: {
    hasWriteAccessToMaster: {default: false},
    detailsConfig: {type: FormDetailsConfig, required: true},
    masterFormConfig: {type: BaseFormConfig, default: ""},
    masterId: {type: String, default: ""},
    mode: {type: String, default: null},
    otherChangesToSave: {type: Boolean, default: false},
    temporaryList: {type: TemporaryList, default: null},
    showFooter: {default: true},
    detailStyle: {default: 'tab'},
    inlineHeight: {default: 350},
    selectionSize: 0,
    showMultiSelect: false,
    tabName: "",
    tempEditMultiSelectFromTab: false,
  },

  watch: {
    masterFormConfig: function (val) {
      // console.log(val);
    },
    masterId: function (val) {
      // console.log(val);
    },
    mode: function (val) {
      // console.log(val);
    },
    otherChangesToSave: function (val) {
      // console.log(val);
    },
    temporaryList: function (val) {
      // console.log(val);
    },
    showFooter: function (val) {
      // console.log(val);
    },
    detailStyle: function (val) {
      // console.log(val);
    },
    inlineHeight: function (val) {
      // console.log(val);
    },
    selectionSize: function (val) {
      this.$emit("update:selectionSize", this.selectionSize);
    },
    showMultiSelect: function (val) {
      this.$emit("update:showMultiSelect", this.showMultiSelect);
    },
    tabName: function (val) {
      this.$emit("update:tabName", this.tabName);
      if(this.list && this.list.$props.detailsConfig.formConfig.formClassLong === this.tabName){
        this.list.$data.refreshIfIsOpen = !this.list.$data.refreshIfIsOpen;
      }
    },
    markReadyToShow: function(val) {
      this.$emit("markReadyToShow")
    },
    tempEditMultiSelectFromTab: function (val) {
      if (this.list) {
        this.list.editMultiSelectFromTab = val;
      }
    },
  },

  async beforeCreate() {

  },
  async created() {

  },

  beforeDestroy() {
    if (this.list) {
      let list = this.list;
      list.beforeUnmount?.();
      list.$destroy?.();
    }
  },

  methods: {

    async mountComponent() {
      if (!this.firstShow) {
        return;
      }
      let ComponentClass;
      if (CLASSES[this.detailsConfig.detailsClass]) {
        ComponentClass = CLASSES[this.detailsConfig.detailsClass];
      } else {
        let clazz = await FormsLoader.getCustomListEditor(this.detailsConfig.detailsClass)();
        let router = this.$router;
        ComponentClass = Vue.extend({...clazz.default, router});
        CLASSES[this.detailsConfig.detailsClass] = ComponentClass;
      }


      let props = {...this.$props};
      if (!props.context) {
        props.context = {}
      }
      props.context['allProps'] = props;
      props.context.isTab = true;

      const list = new ComponentClass({
        propsData: {
          ...props,
        }
      });

      this.$children.push(list);
      list.$parent = this;
      list.$root = this.$root;
      list.$mount();

      this.$refs.holder.appendChild(list.$el);
      list.$on("cancel", () => this.close());
      list.$on("update:showMultiSelect", (val) => {
        this.$emit("update:showMultiSelect", val);
      });
      list.$on("update:tabName", (val) => {
        this.$emit("update:tabName", val);
      });
      list.$on("update:selectionSize", (val) => {
        this.$emit("update:selectionSize", val);
      });
      list.$on("markReadyToShow", () => {
        this.$emit("markReadyToShow");
      });
      this.list = list;
    }
    ,


    async notifyShow() {
      let oldVal = this.firstShow;
      this.firstShow = true;
      if (oldVal !== this.firstShow) {
        this.$nextTick(() =>
            this.mountComponent().then());
      }
    }
    ,

    close() {
      this.$emit('cancel');
    }
    ,


    /**
     * @param masterInstance {RpcClass}
     * @param fieldName {string}
     * @param validatedField {FormValidatedField}
     * @param detailConf {FormDetailsConfig}
     */
    async reloadTabDetail(masterInstance, fieldName, validatedField, detailConf) {
      if (this.temporaryList) {
        let newList = Rpc.Forms.getDetails(this.formConfig.formClassLong, detailConf.detailsClass, masterInstance);
      }
    }
  }
  ,

  data: function () {
    return {
      /** @type {FormConfig}*/
      formConfig: FormsLoader.detectFormConfig(this.detailsConfig.detailsViewClass ?? this.detailsConfig.detailsClass),
      firstShow: false
    }
  }
  ,
}
</script>

<style scoped>

</style>